const assetBasePath = '/game-assets/otama/';

export const OTAMA_ASSETS = {
  commonBg: 'otama-common-bg',
  tick: 'otama-tick',
  introSubtitle: 'otama-intro-subtitle',
  introStartButton: 'otama-intro-start-button',
  introLogo: 'otama-intro-logo',
  introOtto: 'otama-intro-otto',
  introFleasRight: 'otama-intro-fleas-right',
  introFleasLeft: 'otama-intro-fleas-left',
  introReina: 'otama-intro-reina',
  introTitle: 'otama-intro-title',
  selectCat: 'otama-select-cat',
  selectDog: 'otama-select-dog',
  selectTitle: 'otama-select-title',
  catNextButton: 'otama-cat-next-button',
  catReina: 'otama-cat-reina',
  catProductText: 'otama-cat-product-text',
  dogNextButton: 'otama-dog-next-button',
  dogOtto: 'otama-dog-otto',
  dogProductText: 'otama-dog-product-text',
  instructionsSubtitle: 'otama-instructions-subtitle',
  instructionsPlayButton: 'otama-instructions-play-button',
  instructionsFleaRight: 'otama-instructions-flea-right',
  instructionsFleaLeft: 'otama-instructions-flea-left',
  instructionsText: 'otama-instructions-text',
  instructionsTitle: 'otama-instructions-title',
  catFur: 'otama-cat-fur',
  catFlea1: 'otama-cat-flea-1',
  catFlea2: 'otama-cat-flea-2',
  dogFur: 'otama-dog-fur',
  dogFlea1: 'otama-dog-flea-1',
  dogFlea2: 'otama-dog-flea-2',
  catScoreSubtitle: 'otama-cat-score-subtitle',
  catScoreRankingButton: 'otama-cat-score-ranking-button',
  catScoreBg: 'otama-cat-score-bg',
  catScoreProduct: 'otama-cat-score-product',
  catScoreNumberLabel: 'otama-cat-score-number-label',
  catScoreCharacter: 'otama-cat-score-character',
  catScoreTitle: 'otama-cat-score-title',
  catScoreLabel: 'otama-cat-score-label',
  dogScoreSubtitle: 'otama-dog-score-subtitle',
  dogScoreRankingButton: 'otama-dog-score-ranking-button',
  dogScoreBg: 'otama-dog-score-bg',
  dogScoreProduct: 'otama-dog-score-product',
  dogScoreCharacter: 'otama-dog-score-character',
  dogScoreNumberLabel: 'otama-dog-score-number-label',
  dogScoreTitle: 'otama-dog-score-title',
  dogScoreLabel: 'otama-dog-score-label',
  registerRankingButton: 'otama-register-ranking-button',
  registerContactLabel: 'otama-register-contact-label',
  registerLogo: 'otama-register-logo',
  registerNameLabel: 'otama-register-name-label',
  rankingMenuButton: 'otama-ranking-menu-button',
  rankingFireworksRight: 'otama-ranking-fireworks-right',
  rankingFireworksLeft: 'otama-ranking-fireworks-left',
  rankingLogo: 'otama-ranking-logo',
  rankingMisiprox: 'otama-ranking-misiprox',
  rankingNexus: 'otama-ranking-nexus',
  rankingPosition1: 'otama-ranking-position-1',
  rankingPosition2: 'otama-ranking-position-2',
  rankingPosition3: 'otama-ranking-position-3',
  ottoHead: 'otama-otto-head',
  ottoBrow1: 'otama-otto-brow-1',
  ottoBrow2: 'otama-otto-brow-2',
  ottoBody: 'otama-otto-body',
  ottoNoseMouth: 'otama-otto-nose-mouth',
  ottoEye1: 'otama-otto-eye-1',
  ottoEye1Closed: 'otama-otto-eye-1-closed',
  ottoEye2: 'otama-otto-eye-2',
  ottoEye2Closed: 'otama-otto-eye-2-closed',
  ottoEar1: 'otama-otto-ear-1',
  ottoEar2: 'otama-otto-ear-2',
  ottoPaw1: 'otama-otto-paw-1',
  ottoPaw2: 'otama-otto-paw-2',
  ottoScarf: 'otama-otto-scarf',
  ottoMouthClosed: 'otama-otto-mouth-closed',
  ottoSadEyeLeft: 'otama-otto-sad-eye-left',
  ottoSadEyeRight: 'otama-otto-sad-eye-right',
  reynaHead: 'otama-reyna-head',
  reynaBody: 'otama-reyna-body',
  reynaTail: 'otama-reyna-tail',
  reynaEarLeft: 'otama-reyna-ear-left',
  reynaEarRight: 'otama-reyna-ear-right',
  reynaBrowLeft: 'otama-reyna-brow-left',
  reynaBrowRight: 'otama-reyna-brow-right',
  reynaEyeLeft: 'otama-reyna-eye-left',
  reynaEyeLeftClosed: 'otama-reyna-eye-left-closed',
  reynaEyeRight: 'otama-reyna-eye-right',
  reynaEyeRightClosed: 'otama-reyna-eye-right-closed',
  reynaPupil: 'otama-reyna-pupil',
  reynaNoseMouth: 'otama-reyna-nose-mouth',
} as const;

export type OtamaAssetKey = (typeof OTAMA_ASSETS)[keyof typeof OTAMA_ASSETS];

export const OTAMA_IMAGE_FILES: Record<OtamaAssetKey, string> = {
  [OTAMA_ASSETS.commonBg]: 'common-bg.png',
  [OTAMA_ASSETS.tick]: 'garrapata.png',
  [OTAMA_ASSETS.introSubtitle]: 'intro-subtitle.png',
  [OTAMA_ASSETS.introStartButton]: 'intro-start-button.png',
  [OTAMA_ASSETS.introLogo]: 'intro-logo.png',
  [OTAMA_ASSETS.introOtto]: 'intro-otto.png',
  [OTAMA_ASSETS.introFleasRight]: 'intro-fleas-right.png',
  [OTAMA_ASSETS.introFleasLeft]: 'intro-fleas-left.png',
  [OTAMA_ASSETS.introReina]: 'intro-reina.png',
  [OTAMA_ASSETS.introTitle]: 'intro-title.png',
  [OTAMA_ASSETS.selectCat]: 'select-cat.png',
  [OTAMA_ASSETS.selectDog]: 'select-dog.png',
  [OTAMA_ASSETS.selectTitle]: 'select-title.png',
  [OTAMA_ASSETS.catNextButton]: 'cat-next-button.png',
  [OTAMA_ASSETS.catReina]: 'cat-reina.png',
  [OTAMA_ASSETS.catProductText]: 'cat-product-text.png',
  [OTAMA_ASSETS.dogNextButton]: 'dog-next-button.png',
  [OTAMA_ASSETS.dogOtto]: 'dog-otto.png',
  [OTAMA_ASSETS.dogProductText]: 'dog-product-text.png',
  [OTAMA_ASSETS.instructionsSubtitle]: 'instructions-subtitle.png',
  [OTAMA_ASSETS.instructionsPlayButton]: 'instructions-play-button.png',
  [OTAMA_ASSETS.instructionsFleaRight]: 'instructions-flea-right.png',
  [OTAMA_ASSETS.instructionsFleaLeft]: 'instructions-flea-left.png',
  [OTAMA_ASSETS.instructionsText]: 'instructions-text.png',
  [OTAMA_ASSETS.instructionsTitle]: 'instructions-title.png',
  [OTAMA_ASSETS.catFur]: 'cat-fur.png',
  [OTAMA_ASSETS.catFlea1]: 'cat-flea-1.png',
  [OTAMA_ASSETS.catFlea2]: 'cat-flea-2.png',
  [OTAMA_ASSETS.dogFur]: 'dog-fur.png',
  [OTAMA_ASSETS.dogFlea1]: 'dog-flea-1.png',
  [OTAMA_ASSETS.dogFlea2]: 'dog-flea-2.png',
  [OTAMA_ASSETS.catScoreSubtitle]: 'cat-score-subtitle.png',
  [OTAMA_ASSETS.catScoreRankingButton]: 'cat-score-ranking-button.png',
  [OTAMA_ASSETS.catScoreBg]: 'cat-score-bg.png',
  [OTAMA_ASSETS.catScoreProduct]: 'cat-score-product.png',
  [OTAMA_ASSETS.catScoreNumberLabel]: 'cat-score-number-label.png',
  [OTAMA_ASSETS.catScoreCharacter]: 'cat-score-character.png',
  [OTAMA_ASSETS.catScoreTitle]: 'cat-score-title.png',
  [OTAMA_ASSETS.catScoreLabel]: 'cat-score-label.png',
  [OTAMA_ASSETS.dogScoreSubtitle]: 'dog-score-subtitle.png',
  [OTAMA_ASSETS.dogScoreRankingButton]: 'dog-score-ranking-button.png',
  [OTAMA_ASSETS.dogScoreBg]: 'dog-score-bg.png',
  [OTAMA_ASSETS.dogScoreProduct]: 'dog-score-product.png',
  [OTAMA_ASSETS.dogScoreCharacter]: 'dog-score-character.png',
  [OTAMA_ASSETS.dogScoreNumberLabel]: 'dog-score-number-label.png',
  [OTAMA_ASSETS.dogScoreTitle]: 'dog-score-title.png',
  [OTAMA_ASSETS.dogScoreLabel]: 'dog-score-label.png',
  [OTAMA_ASSETS.registerRankingButton]: 'register-ranking-button.png',
  [OTAMA_ASSETS.registerContactLabel]: 'register-contact-label.png',
  [OTAMA_ASSETS.registerLogo]: 'register-logo.png',
  [OTAMA_ASSETS.registerNameLabel]: 'register-name-label.png',
  [OTAMA_ASSETS.rankingMenuButton]: 'ranking-menu-button.png',
  [OTAMA_ASSETS.rankingFireworksRight]: 'ranking-fireworks-right.png',
  [OTAMA_ASSETS.rankingFireworksLeft]: 'ranking-fireworks-left.png',
  [OTAMA_ASSETS.rankingLogo]: 'ranking-logo.png',
  [OTAMA_ASSETS.rankingMisiprox]: 'ranking-misiprox.png',
  [OTAMA_ASSETS.rankingNexus]: 'ranking-nexus.png',
  [OTAMA_ASSETS.rankingPosition1]: 'ranking-position-1.png',
  [OTAMA_ASSETS.rankingPosition2]: 'ranking-position-2.png',
  [OTAMA_ASSETS.rankingPosition3]: 'ranking-position-3.png',
  [OTAMA_ASSETS.ottoHead]: 'otto-head.png',
  [OTAMA_ASSETS.ottoBrow1]: 'otto-brow-1.png',
  [OTAMA_ASSETS.ottoBrow2]: 'otto-brow-2.png',
  [OTAMA_ASSETS.ottoBody]: 'otto-body.png',
  [OTAMA_ASSETS.ottoNoseMouth]: 'otto-nose-mouth.png',
  [OTAMA_ASSETS.ottoEye1]: 'otto-eye-1.png',
  [OTAMA_ASSETS.ottoEye1Closed]: 'otto-eye-1-closed.png',
  [OTAMA_ASSETS.ottoEye2]: 'otto-eye-2.png',
  [OTAMA_ASSETS.ottoEye2Closed]: 'otto-eye-2-closed.png',
  [OTAMA_ASSETS.ottoEar1]: 'otto-ear-1.png',
  [OTAMA_ASSETS.ottoEar2]: 'otto-ear-2.png',
  [OTAMA_ASSETS.ottoPaw1]: 'otto-paw-1.png',
  [OTAMA_ASSETS.ottoPaw2]: 'otto-paw-2.png',
  [OTAMA_ASSETS.ottoScarf]: 'otto-scarf.png',
  [OTAMA_ASSETS.ottoMouthClosed]: 'otto-mouth-closed.png',
  [OTAMA_ASSETS.ottoSadEyeLeft]: 'otto-sad-eye-left.png',
  [OTAMA_ASSETS.ottoSadEyeRight]: 'otto-sad-eye-right.png',
  [OTAMA_ASSETS.reynaHead]: 'reyna-head.png',
  [OTAMA_ASSETS.reynaBody]: 'reyna-body.png',
  [OTAMA_ASSETS.reynaTail]: 'reyna-tail.png',
  [OTAMA_ASSETS.reynaEarLeft]: 'reyna-ear-left.png',
  [OTAMA_ASSETS.reynaEarRight]: 'reyna-ear-right.png',
  [OTAMA_ASSETS.reynaBrowLeft]: 'reyna-brow-left.png',
  [OTAMA_ASSETS.reynaBrowRight]: 'reyna-brow-right.png',
  [OTAMA_ASSETS.reynaEyeLeft]: 'reyna-eye-left.png',
  [OTAMA_ASSETS.reynaEyeLeftClosed]: 'reyna-eye-left-closed.png',
  [OTAMA_ASSETS.reynaEyeRight]: 'reyna-eye-right.png',
  [OTAMA_ASSETS.reynaEyeRightClosed]: 'reyna-eye-right-closed.png',
  [OTAMA_ASSETS.reynaPupil]: 'reyna-pupil.png',
  [OTAMA_ASSETS.reynaNoseMouth]: 'reyna-nose-mouth.png',
};

export function getOtamaAssetUrl(key: OtamaAssetKey) {
  return `${assetBasePath}${OTAMA_IMAGE_FILES[key]}`;
}
